import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

export interface IntrestPageAnswer {
  defaultValue: string;
  defaultLabel: string;
  list: [];
}
@Component({
  selector: "app-selectoption",
  templateUrl: "./selectoption.component.html",
  styleUrls: ["./selectoption.component.scss"],
})
export class SelectoptionComponent implements OnInit {
  @Input() options: any;
  @Input() pageAnswer: Map<string, IntrestPageAnswer>;
  @Input() disabledOption: Map<string, string>;

  @Input("index") index: string;
  @Input("placeholder") placeholder: string;
  selectValue: string = "";
  @Output() selectChange: EventEmitter<string> = new EventEmitter<string>();
  constructor() {}

  ngOnInit(): void {
    //  console.log("this.pageAnswer", this.pageAnswer);
    if (this.pageAnswer) {
      let SelectOption = this.pageAnswer.get(this.index);
      if (SelectOption != undefined) {
        if (this.placeholder == "Select State") {
          this.options = SelectOption.list;
          this.selectValue = SelectOption.defaultValue;
          this.selectChange.emit(this.selectValue);
        }
        if (this.placeholder == "Select Campus") {
          this.selectValue = SelectOption.defaultValue;

          
          this.selectChange.emit(this.selectValue);
        }
        if (this.placeholder == "Select College") {
          this.selectValue = SelectOption.defaultValue;
          this.selectChange.emit(this.selectValue);
        }
      }
    }
  }

  select(type: string, selectedvalue: string, value: string) {
    this.selectChange.emit(value);
  }

  getOptionDisabled(val) {
    if (this.placeholder == "Select College") {
      if (this.disabledOption != undefined) {
        const ar = Array.from(this.disabledOption.values());
        if (ar.includes(val)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  }

  ngOnChanges() {
    if (this.pageAnswer) {
      let SelectOption = this.pageAnswer.get(this.index);
      if (SelectOption == undefined) {
        if (this.placeholder) {
          this.selectValue = "";
        }
      } else {
        if (SelectOption.defaultLabel == "Select State") {
          this.selectValue = "";
        } else {
          if (this.placeholder == "Select College") {
            if (SelectOption.defaultValue == "") {
              this.selectValue = "";
            } else {
              if (SelectOption.defaultValue != "") {
                this.selectValue = SelectOption.defaultValue;
               // this.selectChange.emit(this.selectValue);
              }
            }
          }
          if (this.placeholder == "Select Campus") {
            if (SelectOption.defaultValue != "") {
              this.selectValue = SelectOption.defaultValue;
            }
          }

          if (this.placeholder == "Select State") {
            if (SelectOption.defaultValue != "") {
            //  this.options = SelectOption.list;
              this.selectValue = SelectOption.defaultValue;
            // this.selectChange.emit(this.selectValue);
              //this.selectChange.emit(this.selectValue);
            }
          }
        }
      }
    }
  }
}
